import React from "react";
import Link from "next/link";
import { CLAIMS, regHue } from "../../../utils/niftyData";

interface MarketplaceProps {
  onClaim?: () => void;
}

export default function Marketplace({ onClaim }: MarketplaceProps) {
  const claims = CLAIMS || [];
  const marquee = [...claims, ...claims];
  return (
    <section id="marketplace" className="sec-pad mkt-sec" data-screen-label="Marketplace">
      <div className="mkt-ticker" aria-hidden="true">
        <div className="mkt-track">
          {marquee.map((c, i) => (
            <span className="mkt-tick mono" key={i}>
              <span className="mkt-dot" style={{ background: regHue(c.reg) }}></span>
              {c.asset} <i>{c.id}</i> <b>{c.price} ETH</b> · {c.t} ago
            </span>
          ))}
        </div>
      </div>
      <div className="wrap">
        <div className="sec-tag"><span className="idx">[ 05 ]</span> LIVE MARKETPLACE <span className="rule"></span> <span className="mono mkt-live"><span className="dot dot-live"></span>STREAMING ON-CHAIN</span></div>
        <div className="mkt-table panel" data-reveal>
          <div className="mkt-row mkt-row--head mono">
            <span>ASSET</span><span>REGISTRY</span><span>CATALOG ID</span><span>COORDINATES</span><span>OWNER</span><span className="mkt-r">PRICE</span>
          </div>
          {claims.map((c, i) => (
            <div className="mkt-row" key={i}>
              <span className="mkt-asset">{c.asset}</span>
              <span><span className="reg-badge mono" style={{ ["--rc" as any]: regHue(c.reg) }}>{c.reg}</span></span>
              <span className="mono mkt-mut">{c.id}</span>
              <span className="mono mkt-mut">{c.coord}</span>
              <span className="mono mkt-mut">{c.owner}</span>
              <span className="mkt-r mono mkt-price">{c.price} ETH</span>
            </div>
          ))}
        </div>
        <div className="mkt-cta" data-reveal>
          <Link href="/marketplace" className="btn btn-ghost">VIEW FULL MARKETPLACE →</Link>
        </div>
      </div>
    </section>
  );
}
